import { mountClassic } from '../render/classic/classic-app.js';
import { yukonClassicSpec } from '../variants/yukon/classic-spec.js';

const root = document.getElementById('classic-stage');
if (!root) throw new Error('missing #classic-stage');
mountClassic(yukonClassicSpec, { root, title: 'Yukon' });
